<svg xmlns="http://www.w3.org/2000/svg" width="31.326" height="31.74" viewBox="0 0 31.326 31.74">
    <path
        id="Pfad_95"
        data-name="Pfad 95"
        d="M-3.933-1.449V-13.524h-11.73v-7.8h11.73V-33.189h7.8v11.868h11.8v7.8H3.864V-1.449Z"
        transform="translate(15.663 33.189)"
        fill="#fff"
    />
</svg>
